// extracted by mini-css-extract-plugin
export default {"camouflage":"Camouflages_camouflage"};